{
  "eyebrow": "Utwórz konto",
  "title": "Kilka informacji o Twojej firmie.",
  "sub": "Będziesz głównym administratorem. Po konfiguracji możesz zaprosić kolejnych administratorów.",
  "company": "Firma",
  "companyName": "Nazwa firmy",
  "companyVat": "Numer VAT",
  "companyVatBssHint": "Wymagane do zgłoszeń do belgijskiego ubezpieczenia społecznego (DIMONA).",
  "companyCountry": "Kraj",
  "admin": "Główny administrator",
  "adminFirst": "Imię",
  "adminLast": "Nazwisko",
  "adminEmail": "Służbowy e-mail",
  "adminPhone": "Telefon",
  "adminPw": "Hasło",
  "adminPwHint": "Minimum 10 znaków, w tym jedna cyfra.",
  "adminPwShow": "Pokaż hasło",
  "adminPwHide": "Ukryj hasło",
  "terms": {
    "pre": "Akceptuję",
    "t": "Warunki korzystania",
    "and": "oraz",
    "p": "Politykę prywatności"
  },
  "cta": "Utwórz konto i kontynuuj",
  "errors": {
    "required": "Wymagane",
    "tooShort": "Za krótkie",
    "invalidEmail": "Podaj prawidłowy e-mail",
    "invalidVat": "Podaj prawidłowy numer VAT",
    "invalidBelgianVat": "Podaj prawidłowy belgijski numer VAT (np. BE0123456789).",
    "invalidPhone": "Podaj prawidłowy numer telefonu",
    "passwordWeak": "Minimum 10 znaków z cyfrą",
    "termsRequired": "Musisz zaakceptować warunki",
    "emailExists": "Ten e-mail jest już używany",
    "vatRequiredForBss": "Numer VAT jest wymagany dla belgijskiego ubezpieczenia społecznego",
    "network": "Błąd sieci lub serwera. Spróbuj ponownie.",
    "throttled": "Zbyt wiele prób. Spróbuj ponownie za {{minutes}} min."
  },
  "verify": {
    "awaitingTitle": "Sprawdź skrzynkę e-mail",
    "awaitingSub": "Wysłaliśmy link weryfikacyjny na adres {{email}}. Kliknij go, aby aktywować konto i rozpocząć bezpłatny okres próbny.",
    "awaitingSubNoEmail": "Wysłaliśmy Ci link weryfikacyjny. Kliknij go, aby aktywować konto i rozpocząć bezpłatny okres próbny.",
    "resend": "Wyślij ponownie",
    "resendCooldown": "Wyślij ponownie za {{seconds}}s",
    "verifyingTitle": "Weryfikacja…",
    "successTitle": "Twój bezpłatny 30-dniowy okres próbny się rozpoczął!",
    "successSub": "Bez karty kredytowej. Zaloguj się do panelu, aby zacząć korzystać z Done-it.",
    "errorTitle": "Nie udało się zweryfikować linka",
    "errorSub": "Link mógł wygasnąć. Zacznij ponownie od danych konta.",
    "errorCta": "Wróć do konta",
    "interstitial": "Weryfikacja e-maila",
    "subscribedTitle": "Twoje konto jest gotowe",
    "subscribedSub": "Płatność została już zrealizowana. Zaloguj się do panelu, aby zacząć korzystać z Done-it.",
    "subscribedCta": "Zaloguj się do panelu",
    "successCta": "Otwórz panel",
    "successNote": "W trakcie okresu próbnego otrzymasz kilka pomocnych e-maili, a pod jego koniec link do subskrypcji.",
    "awaitingSubFree": "Wysłaliśmy link weryfikacyjny na adres {{email}}. Kliknij go, aby aktywować darmowe konto — Time Zero jest darmowy na zawsze, bez karty kredytowej.",
    "awaitingSubFreeNoEmail": "Wysłaliśmy Ci link weryfikacyjny. Kliknij go, aby aktywować darmowe konto — Time Zero jest darmowy na zawsze, bez karty kredytowej.",
    "successTitleFree": "Twoje darmowe konto jest gotowe!",
    "successNoteFree": "Time Zero jest darmowy na zawsze w ramach swoich limitów. W dowolnej chwili przejdź na wyższy plan, aby korzystać bez ograniczeń."
  }
}
